import { arrayOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import { isKnowledgeSourceDefinitionResultObject } from "../knowledgeSourceDefinitionId";

export const isKnowledgeSourceDefinitionsResult = objectOf({
  hits: number,
  results: arrayOf(isKnowledgeSourceDefinitionResultObject),
});
